import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import React from 'react';

interface SearchProps {
  handleSearch: () => void;
}

const Search = ({ handleSearch }: SearchProps) => {
  return (
    <IconButton color="inherit" aria-label="iconbutton1" onClick={handleSearch} size="large">
      <SearchIcon />
    </IconButton>
  );
};

export default Search;
